import { RefObject, useEffect, useMemo, useState } from "react";
import { useAuth } from "../../../global-components/src";
import { fetchUsers } from "../../../services/user";
import UserSearch from "./User/User";
import { useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import { UserX } from "lucide-react";
import { UserSearchLoadin } from "./User/UserSearchLoading";
import { User } from "../../../global-components/src/types";

interface Props {
  text: string;
  setText: (value: string) => void;
  showSuggestions: boolean;
  setShowSuggestions: (value: boolean) => void;
  suggestions: User[];
  setSuggestions: (users: User[]) => void;
  textareaRef: RefObject<HTMLInputElement | null>;
  isFocus?: boolean;
  bottom?: string;
}

export default function PreviewSearchPC({
  showSuggestions,
  suggestions,
  text,
  setText,
  setShowSuggestions,
  setSuggestions,
  isFocus,
  textareaRef,
  bottom,
}: Props) {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  // Função de busca com debounce (300ms)
  const debouncedFetchUsers = useMemo(
    () =>
      debounce(async (query: string) => {
        if (!textareaRef.current) return;

        const response = await fetchUsers(query, token);
        if (response?.users) setSuggestions(response.users);
        else setSuggestions([]);
        setShowSuggestions(true);
        setLoading(false);
      }, 500),
    [token, textareaRef, setSuggestions, setShowSuggestions]
  );

  useEffect(() => {
    if (text.trim()) {
      setLoading(true);
      debouncedFetchUsers(text);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
      setLoading(true);
    }

    return () => {
      debouncedFetchUsers.cancel();
    };
  }, [text, debouncedFetchUsers, setSuggestions, setShowSuggestions]);

  const handleSelectUserLocal = (userName: string) => {
    navigate(`/@${userName}`);
  };

  return (
    <>
      {showSuggestions && isFocus && (
        <div
          className="notification_opened preview-search"
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            padding: 5,
            background: "var(--background-post)",
            zIndex: 1000,
            height: "300px",
            width: 500,
            overflowY: "auto",
            top: 45,
            borderRadius: "8px",
            scrollbarWidth: "none", // Firefox
            msOverflowStyle: "none", // IE 10+
          }}
        >
          {loading ? (
            <>
              <UserSearchLoadin loading={loading}/>
            </>
          ) : (
            <>
               {suggestions.length ? (
                <>
                  {suggestions.map((u, index) => (
                    <UserSearch
                      key={index}
                      clasImgAccount="img-account-search img-preview"
                      user={u}
                      onClick={() => {handleSelectUserLocal(u.user_name); setText("")} }
                    />
                  ))}
                </>
              ) : (
                <>
                  <div className="user-select-none row " style={{display: "flex", alignItems: "center", margin: 0, height: "100%"}}>
                      <span className="span-empty">
                          <UserX className="icon-empty" />
                          <h3 className="w-100 text-center">Nenhum usuário encontrado</h3>
                      </span>
                  </div>
                </>
              )}
            </>
          )}
         
        </div>
      )}
    </>
  );
}
